export default __webpack_public_path__ + "static/media/hairstyle.bd5fd906.jpg";